import type { MarketVariants } from '@/lib/i18n'

export type Slide7AccessCopy = {
  heading: string
  body: string
  rule: string
}

export const copy: MarketVariants<Slide7AccessCopy> = {
  US: {
    heading: 'Requests for passwords, PINs, or device access',
    body:
      "Scammers use these to do real damage. If someone contacts you asking for them, it's a scam.",
    rule: "Never give access or information to anyone you haven't verified.",
  },
  ar: {
    heading: 'طلب كلمات المرور أو الرقم السري أو الوصول إلى جهازك',
    body: 'يستخدم المحتالون هذه الأشياء لإلحاق ضرر حقيقي. إذا تواصل معك أحد وطلبها منك، فهذا احتيال.',
    rule: 'لا تمنح أبداً أي وصول أو معلومات لشخص لم تتحقّق منه.',
  },
}
